import * as Sentry from '@sentry/react'
import React, { useEffect } from 'react'
import Navigator from './navigation/navigator'

import { initializeIcons } from '@verzekeringapp-mono/shared/src/utils/initialize_icons'
import EmergencyModalProvider from './providers/EmergencyModalProvider'
import ThemeColorProvider from './providers/ThemeColorProvider'
import ErrorBoundary from './components/ErrorBoundary'
import {
  useAppDispatch,
  useAppSelector
} from '@verzekeringapp-mono/shared/src/hooks/state'
import { getUser } from '@verzekeringapp-mono/shared/src/state/selectors/user'
import { getSubdomain } from '@verzekeringapp-mono/shared/src/utils/hostUtils'
import { setAgencyPrintout } from '@verzekeringapp-mono/shared/src/state/slices/agency_slice'
import { HelmetProvider } from 'react-helmet-async'
import { nl } from 'date-fns/locale'
import { setDefaultOptions } from 'date-fns'
import Modal from './components/Modal'
import {
  getMaintenanceActive,
  getMaintenanceMessage
} from '@verzekeringapp-mono/shared/src/state/selectors/maintenance'
import { maintenanceEnded } from '@verzekeringapp-mono/shared/src/state/slices/maintenance_slice'
import useAgency from '@verzekeringapp-mono/shared/src/hooks/use_agency'
import { registerLocale } from 'react-datepicker'
import { FeedbackModalProvider } from './providers/FeedbackModalProvider'
import NotificationsRefetchProvider from './providers/NotificationsRefetchProvider'

registerLocale('nl', nl)

setDefaultOptions({ locale: nl })

initializeIcons()

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [],
  tracesSampleRate: 0.2,
  environment: process.env.REACT_APP_APP_ENV
})

function App () {
  const user = useAppSelector(getUser)
  const { getAgencyPrintout } = useAgency()
  const dispatch = useAppDispatch()
  const maintenanceActive = useAppSelector(getMaintenanceActive)
  const maintenanceMessage = useAppSelector(getMaintenanceMessage)

  useEffect(() => {
    // If we are logged in we do not have to check agency printout
    if (user) return

    const subDomain = getSubdomain()

    if (
      subDomain &&
      !subDomain.includes('localhost') &&
      !subDomain.includes('nh1816-test') &&
      !subDomain.includes('nh1816-acc') &&
      !subDomain.includes('nh1816-dev')
    ) {
      getAgencyPrintout(subDomain)
    } else {
      dispatch(setAgencyPrintout(undefined))
    }
  }, [])

  const renderMaintenanceModal = () => (
    <Modal
      onClose={() => {
        dispatch(maintenanceEnded())
      }}
    >
      <h1 className='text-2xl font-bold'>Onderhoud</h1>

      <p className='paragraph'>{maintenanceMessage}</p>
    </Modal>
  )

  return (
    <HelmetProvider>
      <ErrorBoundary isLoggedIn={!!user}>
        <EmergencyModalProvider>
          <FeedbackModalProvider>
            <ThemeColorProvider>
              <NotificationsRefetchProvider>
                <Navigator />

                {maintenanceActive && renderMaintenanceModal()}
              </NotificationsRefetchProvider>
            </ThemeColorProvider>
          </FeedbackModalProvider>
        </EmergencyModalProvider>
      </ErrorBoundary>
    </HelmetProvider>
  )
}

export default App
